export const GAME_BOUNDARY_SIZE = 142; // 原100，扩大约√2倍以使边界面积加倍
export const SHIP_TARGET_LENGTH = 11;
export const SHIP_TARGET_WIDTH = 4.5;
export const SHIP_TARGET_HEIGHT = 3.6;
export const SHIP_GLOBAL_SCALE = 1.6;

export const ENABLE_PERF_LOGS = true;
export const PERF_LOG_INTERVAL_MS = 2000;
export const PERF_LOG_MAX_SAMPLES = 120;
export const PERF_LOG_BUFFER_LIMIT = 600;
export const PERF_LOG_ENDPOINT = 'http://localhost:3001/api/perf-logs';
